var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{'d-flex': _vm.addStyle, 'justify-content-center': _vm.addStyle}},[(!_vm.hasData)?[(!_vm.isEmpty(_vm.loadingText))?[_vm._v(" "+_vm._s(_vm.loadingText)+" ")]:_vm._e(),(_vm.hasLoader)?[_c('CSpinner',{attrs:{"color":_vm.spinnerColor}})]:_vm._e()]:_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }